export const environment = {
  production: true,
  basePortalUrl: 'https://cms.staging.ark.wine',
  authUrl: 'https://identity.staging.nationalstorage.com.au',
  userManagementUrl: 'https://api.staging.ark.wine/usermanagement',
  referenceDataUrl: 'https://api.staging.ark.wine/referencedata',
  facilityManagementUrl: 'https://api.staging.ark.wine/facilitymanagement',
  storageManagementUrl: 'https://api.staging.ark.wine/storagemanagement',
  billingUrl: 'https://api.staging.ark.wine/billing',
  paymentsUrl: 'https://api.staging.ark.wine/payments',
  marketplaceUrl: 'https://api.staging.ark.wine/marketplace',
  logisticsUrl: 'https://api.staging.ark.wine/logistics',
  notificationsUrl: 'https://api.staging.ark.wine/notifications',
  marketplaceClientUrl: 'https://marketplace.staging.ark.wine',
  inactivityMonitorIdle: '15',
  inactivityMonitorTimeout: '30',
  showBottleDetailsQRCode: 'true',
  isAccountClosingFeatureEnabled: true,
  sentryDsn: "https://e56697c49358bcc1140ab93febe50dad@o4504760973983744.ingest.us.sentry.io/4508204382420992",
  sentryEnvironmentName: "Staging",
  apiBaseUrl: '#{Api_BaseUrl}'
};
